import axios from "axios";
import { useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { useStateContext } from "../../../Context/ContextProvider";
import domaines from "../../../database/domaines";
import moduleLevel from "../../../database/moduleLevel";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-quill/dist/quill.snow.css';

export default function Modal({ show, handleClose, onModuleAdded }) {

    const [reference, setReference] = useState("");
    const [intitule, setIntitule] = useState("");
    const [description, setDescription] = useState("");
    const [dureH, setDureH] = useState("");
    const [dureJ, setDureJ] = useState("");
    const [prixpersonne, setPrixPersonne] = useState("");
    const [prixgroupe, setPrixGroupe] = useState("");
    const [minAppren, setMinAppren] = useState("");
    const [maxAppren, setMaxAppren] = useState("");

    //pour la tarification
    const [typePrix, setTypePrix] = useState("");

    const navigate = useNavigate();

    // affichage message d'erreur
    const [message, setMessage] = useState(null);

    // affichage des domaines
    const [selectedDomaine, setSelectedDomaine] = useState('');
    const handleDomaineChange = (event) => {
        setSelectedDomaine(Number(event.target.value));
    };

    // affichage moduleLevel
    const [selectLevel, setSelectLevel] = useState('');
    const handleLevelChange = (event) => {
        setSelectLevel(Number(event.target.value));
    }
    const { token, ModuleComptes } = useStateContext();

    const handleSubmitModal = async (e) => {
        e.preventDefault();
        setMessage(null);

        // Frontend validation
        if (!selectedDomaine || !selectLevel || !reference || !intitule || !description) {
            setMessage("Veuillez remplir tous les champs obligatoires.");
            return;
        }

        const formData = {
            idLevel: selectLevel,
            id_domaine_formation: selectedDomaine,
            name: intitule,
            module_tag: intitule,
            subtitle: description,
            module_reference: reference,
            module_dureeH: Math.max(1, parseInt(dureH) || 1),
            module_dureeJ: Math.max(1, parseInt(dureJ) || 1),
            module_price: prixpersonne, // Clé corrigée
            module_prix_groupe: prixgroupe, // Clé corrigée
            module_min_appr: minAppren, // Clé backend attendue
            module_max_appr: maxAppren // Clé ba

        };

        console.log("Form data à envoyer :", formData);
        try {
            const resModal = await axios.post(`https://catalogue.mg.formafusion.io/api/cfp/modules`, formData,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });


            const createModule = resModal.data.data || formData;
            console.log("Module créé :", createModule);

            onModuleAdded(createModule);

            ModuleComptes();

            // RéinisetSelectedDomaine(""); // Au lieu de setDomaine
            setSelectLevel("");
            setSelectedDomaine("");
            setReference("");
            setIntitule("");
            setDescription("");
            setDureH("");
            setDureJ("");
            setPrixPersonne("");
            setPrixGroupe("");
            setMinAppren("");
            setMaxAppren("");
            setMessage("");

            toast.success("Module ajouté avec succes !");

            handleClose();

            setTimeout(() => {
                navigate('cfp/catalogue/preparation')
            }, 2000)

        } catch (error) {
            if (error.response?.data?.message) {
                setMessage(`Erreur serveur : ${error.response.data.message}`);
            } else {
                toast.error("une erreur c'est produit lors de l'ajout");
            }
        }
    };

    if (!show) return null;

    return (
        <>

            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-50 flex items-center justify-center px-4 h-[100vh]">
                <div className="bg-white w-full max-w-4xl mx-auto rounded-2xl overflow-hidden shadow-2xl animate-fade-in " data-aos="fade-down" data-aos-delay="300">

                    {/* Header */}
                    <div className="flex items-center justify-between bg-[#5B345B] px-6 py-4">
                        <h2 className="text-white text-lg md:text-xl font-bold">Ajouter un Cours</h2>
                        <button onClick={handleClose} className="p-2 hover:bg-white/10 rounded-full transition">
                            <RxCross2 size={24} className="text-red-500" />
                        </button>
                    </div>

                    {/* Message */}
                    {message && (
                        <div className={`p-4 text-sm font-medium ${message.includes("succès") ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-aos="zoom-in-up" data-aos-delay="300">
                            {message}
                        </div>
                    )}

                    {/* Formulaire */}
                    <form onSubmit={handleSubmitModal} className="space-y-8 p-6 max-h-[75vh] overflow-y-auto custom-scroll pr-2">

                        {/* === Informations Générales === */}
                        <section>
                            <h3 className="text-lg font-semibold text-[#5B345B] mb-4">Informations Générales</h3>
                            <div className="grid md:grid-cols-2 gap-6">
                                {/* Domaine */}
                                <div>
                                    <label className="text-sm font-medium text-gray-700 block mb-2">Domaine *</label>
                                    <select
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#5B345B]"
                                        value={selectedDomaine}
                                        onChange={handleDomaineChange}
                                    >
                                        <option value="">-- Choisir un domaine --</option>
                                        {domaines.map(d => (
                                            <option key={d.idDomaine} value={d.idDomaine}>{d.nomDomaine}</option>
                                        ))}
                                    </select>
                                </div>

                                {/* Niveau */}
                                <div>
                                    <label className="text-sm font-medium text-gray-700 block mb-2">Niveau *</label>
                                    <select
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#5B345B]"
                                        value={selectLevel}
                                        onChange={handleLevelChange}
                                    >
                                        <option value="">-- Sélectionner votre niveau --</option>
                                        {moduleLevel.map(level => (
                                            <option key={level.idLevel} value={level.idLevel}>{level.module_level_name}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {/* Référence & Intitulé */}
                            <div className="grid md:grid-cols-2 gap-6 mt-4">
                                <div>
                                    <label className="text-sm text-gray-700 block mb-2">Référence *</label>
                                    <input type="text" value={reference} onChange={(e) => setReference(e.target.value)} className="w-full p-3 border rounded-md" required />
                                </div>
                                <div>
                                    <label className="text-sm text-gray-700 block mb-2">Intitulé de la formation *</label>
                                    <input type="text" value={intitule} onChange={(e) => setIntitule(e.target.value)} className="w-full p-3 border rounded-md" required />
                                </div>
                            </div>

                            {/* Description courte */}
                            <div className="mt-4">
                                <label className="text-sm text-gray-700 block mb-2">Description courte *</label>
                                <input type="text" value={description} onChange={(e) => setDescription(e.target.value)} className="w-full p-3 border rounded-md" required />
                            </div>
                        </section>

                        {/* === Tarification === */}
                        <section>
                            <h3 className="text-lg font-semibold text-[#5B345B] mb-4">Prix de la formation</h3>
                            <div className="grid md:grid-cols-2 gap-6">
                                <div>
                                    <label className="text-sm text-gray-700 block mb-2">Prix par personne *</label>
                                    <div className="relative">
                                        <input type="number" value={prixpersonne} onChange={(e) => setPrixPersonne(e.target.value)} className="w-full p-3 border rounded-md pr-12" required />
                                        <span className="absolute right-3 top-1/2 -translate-y-1/2 bg-gray-100 px-2 text-sm rounded text-gray-600">ar</span>
                                    </div>
                                </div>
                                <div>
                                    <label className="text-sm text-gray-700 block mb-2">Prix par groupe *</label>
                                    <div className="relative">
                                        <input type="number" value={prixgroupe} onChange={(e) => setPrixGroupe(e.target.value)} className="w-full p-3 border rounded-md pr-12" required />
                                        <span className="absolute right-3 top-1/2 -translate-y-1/2 bg-gray-100 px-2 text-sm rounded text-gray-600">ar</span>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* === Durée === */}
                        <section>
                            <h3 className="text-lg font-semibold text-[#5B345B] mb-4">Durée de la formation</h3>
                            <div className="grid md:grid-cols-2 gap-6">
                                <div>
                                    <label className="text-sm text-gray-700 block mb-2">Durée (heures) *</label>
                                    <div className="relative" >
                                        <input type="number" value={dureH} onChange={(e) => setDureH(e.target.value)} className="w-full p-3 border rounded-md pr-12" required />
                                        <span className="absolute right-3 top-1/2 -translate-y-1/2 bg-gray-100 px-2 text-sm rounded text-gray-600">heure</span>
                                    </div>

                                </div>
                                <div>
                                    <label className="text-sm text-gray-700 block mb-2">Durée (jours) *</label>
                                    <div className="relative" >
                                        <input type="number" value={dureJ} onChange={(e) => setDureJ(e.target.value)} className="w-full p-3 border rounded-md pr-12" required />
                                        <span className="absolute right-3 top-1/2 -translate-y-1/2 bg-gray-100 px-2 text-sm rounded text-gray-600">jour</span>
                                    </div>

                                </div>
                            </div>
                        </section>

                        {/* === Apprenants === */}
                        <section>
                            <h3 className="text-lg font-semibold text-[#5B345B] mb-2">Nombre d'apprenants</h3>
                            <p className="text-xs text-slate-500 mb-3">Pour les formations de groupe ou de personne, précisez les tailles minimales et maximales.</p>
                            <div className="grid md:grid-cols-2 gap-6">
                                <div>
                                    <label className="text-sm text-gray-700 block mb-2">Minimum *</label>
                                    <input type="number" value={minAppren} onChange={(e) => setMinAppren(e.target.value)} className="w-full p-3 border rounded-md" required />
                                </div>
                                <div>
                                    <label className="text-sm text-gray-700 block mb-2">Maximum *</label>
                                    <input type="number" value={maxAppren} onChange={(e) => setMaxAppren(e.target.value)} className="w-full p-3 border rounded-md" required />
                                </div>
                            </div>
                        </section>

                        {/* === Bouton === */}
                        <div className="text-right">
                            <button type="submit" className="bg-[#5B345B] hover:bg-[#472747] text-white px-6 py-3 rounded-lg text-sm font-semibold transition">
                                Ajouter ce cours
                            </button>
                        </div>
                    </form>
                </div>
            </div>

        </>

    );
}